type CurrentSprintIdState = string | null;

type CurrentSprintIdAction =
  | { type: "SET_CURRENT_SPRINT"; payload: string }
  | { type: "CLEAR_CURRENT_SPRINT" };

const currentSprintId = (state: CurrentSprintIdState = null, action: CurrentSprintIdAction): CurrentSprintIdState => {
  switch (action.type) {
    case "SET_CURRENT_SPRINT": {
      return action.payload;
    }
    case "CLEAR_CURRENT_SPRINT": {
      return null;
    }
    default:
      return state;
  }
};

export default currentSprintId;
